import type { Message } from "./type";

// TODO: 메시지에 대한 실질적인 검증 보강.
export const isMessageEvent = (
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  message: any
): message is Message => {
  return (
    typeof message.type === "string" &&
    !message.type.startsWith("kakaoPixel") &&
    !message.type.startsWith("TikTok") &&
    !message.type.startsWith("webpack") &&
    !message.type.startsWith("orderAuthResult") // hmall 주문 이벤트
  );
};

export const postMessage = (
  recipientWindow: Window,
  message: Message,
  targetOrigin = "*"
) => {
  recipientWindow.postMessage(message, targetOrigin);
};

// https://developer.mozilla.org/en-US/docs/Web/HTTP/Browser_detection_using_the_user_agent
export const hasTouchScreen = () => {
  let result = false;
  if ("maxTouchPoints" in navigator) {
    result = navigator.maxTouchPoints > 0;
  } else if ("msMaxTouchPoints" in navigator) {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    result = (navigator as any).msMaxTouchPoints > 0;
  } else {
    const mQ =
      (window.matchMedia as typeof window.matchMedia | undefined) &&
      matchMedia("(pointer:coarse)");
    if (mQ && mQ.media === "(pointer:coarse)") {
      result = !!mQ.matches;
    } else if ("orientation" in window) {
      result = true; // deprecated, but good fallback
    } else {
      // Only as a last resort, fall back to user agent sniffing
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      const UA = (navigator as any).userAgent;
      result =
        /\b(BlackBerry|webOS|iPhone|IEMobile)\b/i.test(UA) ||
        /\b(Android|Windows Phone|iPad|iPod)\b/i.test(UA);
    }
  }
  return result;
};

/**
 * Determine the mobile operating system.
 * This function returns one of 'iOS', 'Android', 'Windows Phone', or 'unknown'.
 * @see https://stackoverflow.com/a/21742107
 */
export const getOS = () => {
  const userAgent: string =
    navigator.userAgent ||
    navigator.vendor ||
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    (window as any).opera;

  // Windows Phone must come first because its UA also contains "Android"
  if (/windows phone/i.test(userAgent)) {
    return "Windows Phone" as const;
  }

  if (/android/i.test(userAgent)) {
    return "Android" as const;
  }

  // iOS detection from: http://stackoverflow.com/a/9039885/177710
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  if (/iPad|iPhone|iPod/.test(userAgent) && !(window as any).MSStream) {
    return "iOS" as const;
  }

  return "Desktop" as const;
};
